
























import CustomInfiniteLoaderResult from './CustomInfiniteLoaderResult.vue';
import CustomInfiniteLoaderError from './CustomInfiniteLoaderError.vue';
import InfiniteLoading, { StateChanger } from 'vue-infinite-loading';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<CustomInfiniteLoader>({
  components: {
    InfiniteLoading,
    CustomInfiniteLoaderResult,
    CustomInfiniteLoaderError,
  },
  inheritAttrs: false,
})
export default class CustomInfiniteLoader extends Vue {
  // PROPS
  @Prop({ type: Function, required: true })
  infiniteHandler!: ($state: StateChanger) => void;
  @Prop({ type: Boolean, required: false, default: false })
  showsNoMoreMessage!: boolean;

  // FIELDS
  count = 0;

  // METHODS
  restartLoader() {
    const stateChanger = (this.$refs.Infinite as any).stateChanger as StateChanger;
    stateChanger.reset();
  }
  handleOnInfinit($state: StateChanger) {
    this.count += 1;
    return this.infiniteHandler($state);
  }
  reset() {
    (this.$refs.Infinite as any).stateChanger.reset();
  }
}
